import { AppBar, Button, makeStyles, Toolbar } from '@material-ui/core';
import { useCallback, useState, useEffect, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducks/store/store';
import { getIsSignedIn } from '../../reducks/users/selectors';
import {getRole} from "../../reducks/users/selectors";
import { ClosableDrawer } from './ClosableDrawer';
import { HeaderMenus } from './HeaderMenus';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectAppInfo } from '../../reducks/info/selectors';
import { fetchAppInfo } from '../../reducks/info/thunks';

const useStyles = makeStyles({
  root: {
  },
  menuBar: {
    backgroundColor: '#581010',
    color: '#444',
    position: 'relative',
  },
  toolBar: {
    margin: '0 auto',
    maxWidth: 1024,
    width: '100%',
    height: '60px',
  },
  iconButtons: {
    margin: '0 0 0 auto',
    position: 'fixed',
    top: '90vh',
  },
  menuContainer: {  // 追加
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  headerIcon:{
    height: '100%',
  }
});

export const Header: VFC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selector = useSelector((state: RootState) => state);
  const pathName = useLocation().pathname;
  const navigate = useNavigate();
  const role = getRole(selector);

  // ログイン状態を取得
  const isSignedIn = getIsSignedIn(selector);
  // ドロワーの開閉状態
  const [open, setopen] = useState<boolean>(false);

  const appInfo = useSelector(selectAppInfo);
  useEffect(() => {
    if (appInfo.status === 'idle') dispatch(fetchAppInfo());
  }, [dispatch, appInfo.status]);
  const maintenanceRegex = /.maintenance/;
  const inMaintenancePage = maintenanceRegex.test(window.location.href);

  /**
   * ドロワーメニューを開閉する.
   * 
   * @param event
   */
  const handleDrawerToggle = useCallback((e) => {
    // TabかShiftを押しても閉じないように
    if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift')) {
      return;
    }
    setopen(!open);
  }, [open, setopen]);

  return (
    <header className={classes.root}>
      <AppBar position='sticky' className={classes.menuBar}>
        <Toolbar className={classes.toolBar}>
          {isSignedIn && (
            <img
              className={classes.headerIcon}
              src={'/img/logo.png'}
              alt='logo'
              onClick={() => navigate('/')}
            />
          )}
          {!isSignedIn && (
            <img
              className={classes.headerIcon}
              src={'/img/logo.png'}
              alt='logo'
              onClick={() => navigate('/signin')}
            />
          )}
          <span className={`lg:hidden ${classes.menuContainer}`}>
            {!inMaintenancePage && (
              <>
              <Button
                color="inherit"
                style={{ color: 'white', fontSize: '1.1em' }}
                onClick={() =>  navigate('/order/history')}
              >
                注文履歴
              </Button>
              <div style={{ height: '26px', width: '1px', backgroundColor: '#b38686', margin: '8px 8px' }}></div>  {/* 縦棒 */}
              <Button
                color="inherit"
                style={{ color: 'white', fontSize: '1.1em' }}
                onClick={() =>  navigate('/user/my-page')}
              >
                アカウント
              </Button>
            </>
            )}
          </span>
          {(isSignedIn && !(pathName === '/cart' || pathName === '/order/confirm' || pathName === '/order/complete' || pathName.includes('/product/edit') || pathName === '/order/history' || pathName.includes('/user/my-page') || pathName === '/maintenance' || pathName === '/admin/sort' || ( role === 'admin' && pathName === '/'))) && (
            <div className={classes.iconButtons}>
              <HeaderMenus handleDrawerToggle={handleDrawerToggle}/>
            </div>
          )}
        </Toolbar>
        <ClosableDrawer open={open} onClose={handleDrawerToggle} />
      </AppBar>
    </header>
  );
};
